'use strict';

//Returns a slice of an array
intellidealerAppCoreModule.filter('sortProperty', function () {
  return function(array) {
    return array.filter(function (element) {
      return !!element.property;
    });
  };
});